import {includes} from '@shared/helpers/collection'
import {createStateMaker} from '@shared/helpers/object'

import {SaleHistoryState, SaleStatus, SaleStatusType} from '../interfaces'

export const getInitialState = (): SaleHistoryState => ({
    /** 결제 일시 (ISO 형식) */
    paymentDate: '',
    statusSummaries: [],
})

export const makeMock = createStateMaker<SaleHistoryState>(getInitialState)

export const getClaimType = (status?: SaleStatusType): 'CANCEL' | 'RETURN' | 'NONE' => {
    switch (true) {
        case includes(status, [SaleStatus.CANCEL_REQUEST, SaleStatus.CANCEL_DONE, SaleStatus.CANCELED_BY_NOPAYMENT]):
            return 'CANCEL'
        case includes(status, [SaleStatus.RETURN_REQUEST, SaleStatus.RETURN_COLLECT_DONE, SaleStatus.RETURN_REFUND]):
            return 'RETURN'
        default:
            return 'NONE'
    }
}
